import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "fieldset"
    ]
    fieldsetEnabled = false;

    enableFieldset(event) {
        if (!this.fieldsetEnabled &&
            event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
            this.fieldsetTarget.disabled = false
            this.fieldsetEnabled = true
            this.resetClientSideValidations();
        }
    }

    resetClientSideValidations() {
        const form = $(this.fieldsetTarget).closest('form');
        form.resetClientSideValidations();
        form.enableClientSideValidations();
    }

}